import React, { useState, useEffect } from 'react'
import { StepContext } from './contexts'
import { useForm } from './consumers'


const StepProvider = ({ initialSteps, env, children }) => {
    const form = useForm()

    const [steps, setSteps] = useState(initialSteps || [])

    const [stepSubmitted, setStepSubmitted] = useState(false)

    const { validateForm, updateValidationSchema, setFieldTouched } = form

    const [stepIndex, setStepIndex] = useState(env.index || 0)

    const step = steps[stepIndex]

    useEffect(() => {
        window.scrollTo(0, 0)
        updateValidationSchema(steps[stepIndex].validation)
        setStepSubmitted(false)
        // eslint-disable-next-line
    }, [stepIndex])

    const validateSlide = errors => {
        let validated = true

        for (let key in errors) {
            validated = false
            setFieldTouched(key)
        }

        return validated
    }

    const removeStep = slideToBeRemoved => {
        for (let i = 0; i < steps.length; i++) {
            if (steps[i].name === slideToBeRemoved.name) {
                setSteps([...steps.filter(slide => slide.name !== slideToBeRemoved.name)])
            }
        }
    }

    const addStep = (slide, index) => {
        steps.splice(index, 0, slide)
        setSteps([...steps])
    }

    const stepPrev = () => {
        if (stepIndex > 0) {
            setStepIndex(index => index - 1)
        }
    }

    const stepNext = () => {
        validateForm()
            .then(errors => {
                setStepSubmitted(true)

                if (false === validateSlide(errors)) {
                    return
                }

                if (stepIndex < steps.length - 1) {
                    
                    setStepIndex(index => index + 1)
                }
            })
    }

    const updateStep = (step) => {
        steps[stepIndex] = step

        setSteps([...steps])
    }

    function setStepDisabled(value) {
        step.disabled = value
        updateStep(step)
    }

    return (
        <StepContext.Provider value={{
            setSteps: setSteps,
            stepPrev,
            stepNext,
            setStepIndex,
            stepSubmitted,
            setStepSubmitted,
            setStepDisabled,
            removeStep,
            addStep,
            steps,
            stepIndex,
            updateStep,
            step: step
        }}>
            {children}
        </StepContext.Provider>
    )
}

export default StepProvider